<div class="stf-automation" ng-controller="ProfileController">
  <div class="card mb-3 bg">
    <div class="row flexCenter" style="color:#757575;font-size: 15px; width: 100%;">
      <div class="col-2 col-md-2" style="padding: 1em;">
        <span>
          <i class="fa fa-user custom-size"></i>
        </span>
      </div>
      <div class="m-10 col-4 col-md-4">
        <span class="m-10 d-block">{{"Full Name : " | translate}}</span>
        <span class="m-10 d-block">{{"Email : " | translate}}</span>
        <span class="m-10 d-block">{{"Role :" | translate}}</span>
        <span class="m-10 d-block">{{"Last Logged In :" | translate}}</span>
      </div>
      <div class="m-10  col-4 col-md-4">
        <span class="m-10 f-w-bold d-block">{{currentUser.userObj.name}}</span>
        <span class="m-10 f-w-bold d-block">{{currentUser.userObj.email}}</span>
        <span class="m-10 f-w-bold d-block">{{currentUser.userObj.privilege}} </span>
        <span class="m-10 f-w-bold d-block">{{istTime}}</span>

      </div>
    </div>
  </div>
  <!-- password update for users only  -->
  @if (currentUser.userObj.privilege!='admin') {
    <div class="card mb-3 bg">
      <!-- user authentication with old password -->
      <div class="col-12 col-md-12" style="padding: 1em;">
        <i class="fa fa-user"></i>
        <span>{{" Change the Login Password" | translate}}</span>
        <button class="btn btn-sm btn-primary" style="left: 1em; position: relative;" (click)="openchangepass()">{{"Change Password" | translate}}</button>
      </div>
      @if (changePass) {
        <div class="card">
          <div class="p-4 bg-gray-100 rounded shadow-md">
            <h2 class="text-lg font-semibold mb-4">{{"Change Password" | translate}}</h2>
            <form (ngSubmit)="onSave()" #passwordForm="ngForm" style="flex-direction: column;">
              <div class="mb-4">
                <label for="oldPassword" class="mt-1 block text-sm font-medium text-gray-700">{{"Old Password" | translate}}</label>
                <input [type]="showPasswordOld?'password':'text'" id="oldPassword" name="oldPassword" required
                  class="pass mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-500"
                  [(ngModel)]="oldPassword">
                <button type="button" class="toggle-password" (click)="togglePasswordVisibilityOld()">
                  <i [ngClass]="showPasswordOld ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                </button>
              </div>
              <div class="mb-4">
                <label for="newPassword" class="mt-1 block text-sm font-medium text-gray-700">{{"New Password" | translate}}</label>
                <input [type]="showPasswordNew?'password':'text'" id="newPassword" name="newPassword" required
                  class="pass mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-500"
                  [(ngModel)]="newPassword">
                <button type="button" class="toggle-password" (click)="togglePasswordVisibilityNew()">
                  <i [ngClass]="showPasswordNew ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                </button>
              </div>
              <div class="mb-4">
                <label for="confirmPassword" class="mt-1 block text-sm font-medium text-gray-700">{{"Confirm New Password" | translate}}</label>
                <input [type]="showPasswordCnfrm?'password':'text'" id="confirmPassword" name="confirmPassword" required
                  class="pass mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-500"
                  [(ngModel)]="confirmPassword">
                <button type="button" class="toggle-password" (click)="togglePasswordVisibilityCnfrm()">
                  <i [ngClass]="showPasswordCnfrm ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                </button>
              </div>
              <button type="submit" class="btn btn-primary btn-sm">
                {{"Save" | translate}}
              </button>
            </form>
          </div>
        </div>
      }
    </div>
  }
  <!-- <div class="card bg">
  <div class="m-10 col-md-11 w-95" style="margin-left: 2rem;">
    <h5>License Details :</h5>
    <table class="mt-15 table table-bordered table-striped" style="color:black;font-weight:bold;font-size: 13px;">
      <thead style="background-color:grey;color:white;">
        <tr>
          <th>Plan Type </th>
          <th>From </th>
          <th>To </th>
          <th>Status </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of licenseData">
          <td>{{data.planType}} </td>
          <td>{{data.startDate}} </td>
          <td>{{data.endDate}} </td>
          <td>{{data.status}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div> -->
</div>
<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>